var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirewallIcon24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1224 1.14697L21.6129 3.03012C22.2703 3.19458 22.124 6.55591 22.124 6.55591C22.124 20.3782 11.9284 23 11.9284 23C11.9284 23 1.86605 20.0857 1.86605 6.55591C1.8476 5.87848 1.86671 3.19458 2.52413 3.03012L10.7344 1.14697C11.5182 0.951009 12.3385 0.951009 13.1224 1.14697Z",
    stroke: "#212B36",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 11.8471C16.2857 14.7042 14.1428 16.1328 12 16.1328C9.85709 16.1328 7.71423 14.7042 7.71423 11.8471C7.71423 9.70425 8.78566 8.63282 9.49995 8.27567C9.49995 9.3471 9.85709 10.0614 10.2142 10.4185C12.3571 9.70425 12.7142 7.56139 12.7142 6.13281C14.1428 7.20424 16.2857 8.98996 16.2857 11.8471Z",
    stroke: "#212B36",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewallIcon24);
export default __webpack_public_path__ + "static/media/firewall_icon_24.245b28efbe7153151acffbd3c76c54ea.svg";
export { ForwardRef as ReactComponent };